<template>
  <div
    ref="container"
    class="container">
    <progress-bar
      v-if="imagesLoaded"
      :perc="currentPerc" />
    <intro-section ref="introSection" />
    <div
      ref="imageHolder"
      class="image-holder">
      <scroll-images
        :scroll-position="scrollLeft"
        @images-loaded="onImagesLoaded" />
    </div>
    <outro-section
      v-if="allowOutro"
      ref="outroSection" />
  </div>
</template>
<script>

import IntroSection from 'components/IntroSection';
import OutroSection from 'components/OutroSection';
import ScrollImages from 'components/ScrollImages';
import ProgressBar from 'components/ProgressBar';
import { trackPage } from '../utils/track';

export default {
  components: {
    IntroSection,
    OutroSection,
    ScrollImages,
    ProgressBar,
  },
  data() {
    return {
      container: undefined,
      scrollLeft: 0,
      fullwidth: 0,
      currentPerc: 0,
      trackedPerc: 0,
      isDragging: false,
      prevMousePos: 0,
      scrollDiff: 0,
      scrollOutInterval: undefined,
      allowOutro: false,
      imagesLoaded: false,
    };
  },
  mounted() {
    this.container = this.$refs.container;

    this.setIntroSpace();
    this.setEvents();
  },
  methods: {
    setIntroSpace() {
      let leftSpace = this.$refs.introSection.$el.getBoundingClientRect().width / 4;
      if (leftSpace < this.$refs.introSection.$el.getBoundingClientRect().width - 400) {
        leftSpace = this.$refs.introSection.$el.getBoundingClientRect().width - 400;
      }
      this.$refs.imageHolder.style.left = `${leftSpace}px`;

      // set an timeout in case an image won't load in time
      setTimeout(() => {
        this.replaceOutro(false);
      }, 4000);
    },
    onImagesLoaded() {
      this.imagesLoaded = true;
      this.replaceOutro(true);
    },
    replaceOutro(force = false) {
      if (!this.allowOutro || force) {
        this.allowOutro = true;
        this.$nextTick(() => {
          this.$refs.outroSection.$el.style.left = `${this.$refs.imageHolder.getBoundingClientRect().width + (window.innerWidth / 2)}px`;
          this.fullwidth = this.$refs.imageHolder.getBoundingClientRect().width + this.$refs.outroSection.$el.getBoundingClientRect().width;
        });
      }
    },
    handleMouseWheel(e) {
      const delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
      this.$refs.container.scrollLeft -= (delta * 40);
      e.preventDefault();
    },
    handleScrolling() {
      this.scrollLeft = this.container.scrollLeft;
      this.$emit('scroll-position-change', this.container.scrollLeft);
      this.checkTracking();
    },
    checkTracking() {
      this.currentPerc = (this.scrollLeft / (this.fullwidth - window.innerWidth)) * 100;
      if (this.currentPerc >= this.trackedPerc + 10) {
        this.trackedPerc += 10;
        trackPage(`${this.trackedPerc}-percent`);
      }
    },
    setEvents() {
      this.$refs.container.addEventListener('scroll', () => {
        this.handleScrolling();
      });
      this.$refs.container.addEventListener('mousewheel', (e) => {
        this.handleMouseWheel(e);
      });

      // FF special
      this.$refs.container.addEventListener('DOMMouseScroll', (e) => {
        this.handleMouseWheel(e);
      });

      window.addEventListener('mousemove', (event) => {
        if (this.isDragging) {
          this.scrollDiff = this.prevMousePos - event.clientX;
          this.$refs.container.scrollLeft += this.scrollDiff;
          this.prevMousePos = event.clientX;
        }
      });

      window.addEventListener('mousedown', (event) => {
        clearInterval(this.scrollOutInterval);
        this.prevMousePos = event.clientX;
        this.isDragging = true;
      });

      window.addEventListener('mouseup', () => {
        this.isDragging = false;

        // negate speed when scrolling to fast
        if (this.scrollDiff > 35) {
          this.scrollDiff = 35;
        } else if (this.scrollDiff < -35) {
          this.scrollDiff = -35;
        }

        this.scrollOutInterval = setInterval(() => {
          this.scrollDiff += this.scrollDiff > 0 ? -0.3 : 0.3;
          this.$refs.container.scrollLeft += this.scrollDiff;
          if (this.scrollDiff < 1 && this.scrollDiff > -1) {
            clearInterval(this.scrollOutInterval);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .container {
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    overflow-x: scroll;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  .image-holder {
    width: auto;
    height: 60%;
    position: absolute;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ScrollContainer.vue